import { threadQueries } from "@/hooks/useThreads.tsx";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

/**
 * Listens for AppState transitions from the native WebView shell.
 *
 * On resume, the WebView's socket may have missed `thread:mutated` events
 * while the app was backgrounded (socket.io does not replay missed events).
 * The injected `focus` event is not enough on its own because the thread
 * detail query has a 5-minute `staleTime`, so React Query's focusManager
 * treats it as fresh and skips the refetch — leaving the "working" counter
 * stuck on threads whose agent finished while backgrounded.
 */
export const NativeAppStateListener = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!window.isWebView) return;

    const handler = () => {
      void queryClient.invalidateQueries({ queryKey: threadQueries.all() });
    };
    window.addEventListener("nativeAppResume", handler);
    return () => window.removeEventListener("nativeAppResume", handler);
  }, [queryClient]);

  return null;
};
